{
  "login": "Masuk",
  "logout": "Keluar",
  "signOut": "Keluar",
  "username": "Nama Pengguna",
  "password": "Kata Sandi",
  "forgotPassword": "Lupa Kata Sandi?",
  "rememberMe": "Ingat saya",
  "loginButton": "Masuk",
  "loginError": "Nama pengguna atau kata sandi salah",
  "sessionExpired": "Sesi Anda telah berakhir. Silakan masuk kembali.",
  "passwordChangedRelogin": "Your password was changed. Please sign in with your new password.",
  "signingIn": "Sedang masuk...",
  "loginSuccess": "Berhasil masuk",
  "showPassword": "Tampilkan kata sandi",
  "hidePassword": "Sembunyikan kata sandi",
  "onboardingPrompt": "Untuk rumah sakit atau klinik Anda?",
  "onboardingCta": "Ajukan onboarding",
  "loginFailed": "Gagal masuk",
  "seatCapReached": "Batas pengguna untuk lisensi ini telah tercapai. Hubungi administrator Anda.",
  "mfaCodeLabel": "Kode verifikasi",
  "mfaCodePrompt": "Masukkan kode 6 digit dari aplikasi autentikator Anda untuk menyelesaikan proses masuk.",
  "mfaSetupRequired": "Organisasi Anda mewajibkan autentikasi multifaktor. Siapkan aplikasi autentikator Anda untuk melanjutkan.",
  "mfaCodePlaceholder": "Kode 6 digit",
  "mfaInvalidCode": "Kode verifikasi tidak valid",
  "pages": {
    "userProfile": {
      "title": "Profil Saya",
      "loading": "Memuat profil...",
      "sections": {
        "profilePicture": "Foto Profil",
        "personalInformation": "Informasi Pribadi",
        "changePassword": "Ubah Kata Sandi",
        "multiFactorAuth": "Autentikasi Multi-Faktor"
      },
      "fields": {
        "fullName": "Nama Lengkap",
        "email": "Email",
        "phone": "Telepon",
        "currentPassword": "Kata Sandi Saat Ini",
        "newPassword": "Kata Sandi Baru",
        "confirmPassword": "Konfirmasi Kata Sandi Baru",
        "required": "*"
      },
      "actions": {
        "saveChanges": "Simpan Perubahan",
        "changePassword": "Ubah Kata Sandi",
        "setUpMfa": "Aktifkan Autentikasi Multi-Faktor",
        "uploadAvatar": "Unggah",
        "changeAvatar": "Ganti",
        "removeAvatar": "Hapus",
        "verify": "Verifikasi"
      },
      "avatar": {
        "alt": "Avatar",
        "helperText": "PNG, JPEG atau WebP, maksimal 4 MB. Diubah ukurannya menjadi {{size}}×{{size}} sebelum diunggah."
      },
      "mfa": {
        "enabledMessage": "Autentikasi multi-faktor telah aktif pada akun Anda.",
        "intro": "Aktifkan autentikasi multi-faktor untuk menambah lapisan keamanan pada akun Anda.",
        "scanInstruction": "Pindai URI ini dengan aplikasi autentikator, atau salin secara manual:",
        "copyUri": "Salin URI",
        "verificationCode": "Kode Verifikasi",
        "codePlaceholder": "Masukkan kode 6 digit"
      },
      "validation": {
        "fullNameRequired": "Nama lengkap wajib diisi",
        "emailRequired": "Email yang valid wajib diisi",
        "currentPasswordRequired": "Kata sandi saat ini wajib diisi",
        "newPasswordTooShort": "Kata sandi minimal 8 karakter",
        "confirmPasswordRequired": "Mohon konfirmasi kata sandi Anda",
        "passwordsMismatch": "Kata sandi tidak cocok"
      },
      "toasts": {
        "profileUpdated": "Profil berhasil diperbarui",
        "profileUpdateFailed": "Gagal memperbarui profil",
        "passwordChanged": "Kata sandi berhasil diubah",
        "passwordChangeFailed": "Gagal mengubah kata sandi. Periksa kata sandi saat ini Anda.",
        "mfaSetupFailed": "Gagal memulai pengaturan autentikasi multi-faktor",
        "mfaEnabled": "Autentikasi multi-faktor diaktifkan",
        "mfaInvalidCode": "Kode verifikasi tidak valid",
        "avatarUpdated": "Avatar diperbarui",
        "avatarUpdateFailed": "Gagal memperbarui avatar",
        "avatarRemoved": "Avatar dihapus",
        "avatarRemoveFailed": "Gagal menghapus avatar",
        "imageTooLarge": "Gambar harus di bawah 4 MB",
        "imageTooLargeServer": "Gambar terlalu besar — coba berkas yang lebih kecil",
        "copiedToClipboard": "Disalin ke papan klip"
      }
    }
  },
  "components": {
    "sessionTimeoutWarning": {
      "critical": "Sesi Anda akan berakhir dalam waktu kurang dari 1 menit. Segera simpan pekerjaan Anda.",
      "expiringSoon_one": "Sesi Anda akan berakhir dalam {{count}} menit.",
      "expiringSoon_other": "Sesi Anda akan berakhir dalam {{count}} menit.",
      "extendButton": "Perpanjang Sesi"
    }
  },
  "signInMethod": "Sign-in method",
  "signInPassword": "Password",
  "signInDirectory": "Directory",
  "signInSso": "SSO",
  "ldapDirectory": "Directory",
  "ldapLoading": "Loading directories…",
  "ldapEmpty": "No directories configured — contact your administrator.",
  "ssoEmail": "Work email",
  "ssoEmailPlaceholder": "you@hospital.org",
  "ssoContinue": "Continue with SSO",
  "ssoChecking": "Checking…",
  "ssoChoose": "Choose your sign-in provider",
  "ssoContinueWith": "Continue with {{name}}",
  "ssoNoneFound": "No SSO provider for this domain — try password or directory sign-in.",
  "ssoCallbackTitle": "Completing sign-in…",
  "ssoCallbackFailed": "Single sign-on failed",
  "ssoCallbackMissing": "Missing sign-in response — please try again.",
  "ssoBackToLogin": "Back to sign-in",
  "setup": {
    "title": "Penyiapan awal",
    "subtitle": "Buat akun administrator pertama untuk instalasi ini.",
    "username": "Nama Pengguna",
    "password": "Kata Sandi",
    "confirmPassword": "Konfirmasi kata sandi",
    "fullName": "Nama lengkap (opsional)",
    "fullNamePlaceholder": "mis. Tan Wei Ming",
    "email": "Email (opsional)",
    "submit": "Buat akun administrator",
    "submitting": "Membuat akun…",
    "usernameHint": "3–64 karakter: huruf kecil, digit, titik, garis bawah, dan tanda hubung.",
    "passwordHint": "Minimal 12 karakter, dengan huruf besar, huruf kecil, digit, dan karakter khusus.",
    "errUsername": "Gunakan 3–64 karakter: a–z, 0–9, titik, garis bawah, atau tanda hubung.",
    "errPasswordLength": "Kata sandi minimal 12 karakter.",
    "errPasswordUpper": "Kata sandi harus mengandung huruf besar.",
    "errPasswordLower": "Kata sandi harus mengandung huruf kecil.",
    "errPasswordDigit": "Kata sandi harus mengandung digit.",
    "errPasswordSpecial": "Kata sandi harus mengandung karakter khusus.",
    "errConfirmRequired": "Harap konfirmasi kata sandi.",
    "errConfirmMismatch": "Kata sandi tidak cocok.",
    "errFullName": "Nama lengkap maksimal 100 karakter.",
    "errEmail": "Masukkan alamat email yang valid.",
    "successTitle": "Akun administrator dibuat",
    "successBody": "Akun “{{username}}” sudah siap. Masuk untuk melanjutkan.",
    "goToLogin": "Ke halaman masuk",
    "claimedTitle": "Penyiapan sudah selesai",
    "claimedBody": "Sistem ini sudah memiliki administrator. Masuk dengan akun Anda.",
    "networkError": "Tidak dapat menghubungi server. Periksa koneksi Anda dan coba lagi.",
    "retry": "Coba lagi",
    "rateLimited": "Terlalu banyak percobaan. Tunggu sebentar dan coba lagi.",
    "usernameTaken": "Nama pengguna ini sudah digunakan.",
    "submitFailed": "Tidak dapat membuat akun. Silakan coba lagi."
  }
}
